import { Injectable } from '@angular/core';
import { AppInjector } from '../../app-injector';
import { IntegrationItemServiceInf, StatusString} from '../interfaces/integrations';
import { Account, RouterService } from '@mitel/cloudlink-sdk';
import { AdminService } from './admin.service';
import { MenuItem } from '../interfaces/menu-item'; 
import { IntegSharedCCService } from './integ-shared-cc.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogs } from '../../shared/components/dialogs/confirmation-dialog/confirmation-dialogs.enum';
import { RBACAuthGuardService } from '../guards/rbac-auth-guard.service';
import { ActionType, CategoryId } from '../utils/rbac.util';
import { XLaunchService } from './x-launch.service';

@Injectable({
	providedIn: 'root'
})

// MITEL ONE CX
// this service will hide whatever implementation we eventually have for gettinng the list of integrations
// types. Right now it is static
export class IntegCallCenterService implements IntegrationItemServiceInf {
	private adminService: AdminService = undefined;
	private sharedCCService: IntegSharedCCService = undefined;
	public dialog: MatDialog;
	private rbacAuthGuardService: RBACAuthGuardService;
	private routerService: RouterService;
	private xlaunchService: XLaunchService;

	constructor(  ) 
	{
	}

	initServices()
	{
		if ( !this.adminService )
			this.adminService = AppInjector.injector.get(AdminService);

		if ( !this.sharedCCService )
			this.sharedCCService = AppInjector.injector.get(IntegSharedCCService);

		if ( !this.dialog )
			this.dialog = AppInjector.injector.get(MatDialog);

		if ( !this.rbacAuthGuardService )
			this.rbacAuthGuardService = AppInjector.injector.get(RBACAuthGuardService);

		if ( !this.routerService )
			this.routerService = AppInjector.injector.get(RouterService);

		if ( !this.xlaunchService )
			this.xlaunchService = AppInjector.injector.get(XLaunchService);
	}
	
	canBeSelected(account: Account): Promise<boolean>
	{
		this.initServices();
		if ( this.xlaunchService.isXLaunchedFromBoss() )
			return Promise.resolve(true);
		return Promise.resolve(false);
	}

	getConfigurationDialog() : any
	{
		this.initServices();
		return this.sharedCCService.getConfigurationDialog();
	}

	isSetupComplete(account: Account) : Promise<boolean>
	{
		this.initServices();
		// current understanding on whether setup is complete
		// check for the cx tag to determine if setup is complete
		// Account tag = cx - value = cc-next-beta and the state- i.e. the tag indicates the setup is run and the value is the edition.
		// if the state tag is set to FINISHED, setup is complete, otherwise it is not
		return this.sharedCCService.isSetupComplete( account, 'cc-next-beta' );
	}

	// Free trial is being removed. But is it forever? I am keeping this around for now
	// isEligibleForFreeTrial(account: Account): Promise<boolean>
	// {
	// 	this.initServices();
	// 	return this.sharedCCService.isEligibleForFreeTrial( account, "ContactCenter" );
	// }

	// Free trial is being removed. But is it forever? I am keeping this around for now
	// async grantFreeTrial(account: Account, product: any): Promise<any>
	// {
	// 	this.initServices();
	// 	return this.sharedCCService.grantFreeTrial(
	// 			account,
	// 			product,
	// 			environment.callCenterSpa.free_ccnextProductRatePlanChargeId, 
	// 			environment.callCenterSpa.free_ccnextProductRatePlanId);
	// }

	handleIntegrationStateChange(account: Account, state: boolean, productsPriorChange?: string[]): Promise<any>
	{
		this.initServices();
		return this.sharedCCService.handleIntegrationStateChange( 
				account, 
				state,
				"ContactCenter");
	}

	postCompleteIntegration(account: Account): Promise<boolean>
	{
		return Promise.resolve(true)
	}

	getStatusString(account: Account): Promise<StatusString>
	{
		return undefined;
	}

	getConfigButtonLabel(account: Account): Promise<string>
	{
		return undefined;
	}

	isButtonDisabled(account: Account): Promise<boolean>
	{
		return Promise.resolve(false);
	}

	canDeleteIntegration(account: Account): Promise<boolean>
	{
		this.initServices();
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { mode: ConfirmationDialogs.REMOVE_CCNEXT_CONFIRMATION } });
		return dialogRef.afterClosed().toPromise().then(result => {
			return result;
		});
	}

	getLeftNavMenus( account: Account ): Promise<MenuItem[]>
	{
		this.initServices();
		return this.sharedCCService.getLeftNavMenus(account, 'cc-next-beta');
	}

	// it appears we need to test these conditions in several places, so separate function
	// caller is responsible for any spinners they want to display
	// caller is responsible to handle any errors generated as appropriate to their situation
	determineIfAccountIsEligibleForAFreeTrial( account: Account, product: string ): Promise<boolean>
	{
		this.initServices();
		return this.sharedCCService.determineIfAccountIsEligibleForAFreeTrial( account, product );
	}

	isIntegrationStateChangeable(account: Account): Promise<boolean> {
		this.initServices();
		
		let isDenied = this.rbacAuthGuardService.isPermissionDeniedForUser(CategoryId.INTEGRATIONS, ActionType.DELETE);
		return Promise.resolve(!isDenied);
	}
}
